module.exports = __webpack_public_path__ + "img/img-80.6e9e59fc.png";